export const allAccessRoutes = {
  loginPage: '/login',
  forgotPasswordPage: '/forgot',
  resetPasswordPage: '/reset',
  activateAccountPage: '/activate',
  phoneLoginPage: '/phone',
  signupPage: '/signup',
  singleSignOn: '/sso'
}

const authorizedRoutes = {
  welcomePage: '/welcome',
  logoutPage: '/logout',
  alertsPage: '/alerts',
  memberDashboardPage: '/memberDashboard',
  accountPage: '/account',
  helpPage: '/help',
  profilePage: '/profile',
  chatPage: '/chats',
  membersPage: '/members',
  careplanPage: '/careplan',
  analyticsPage: '/analytics'
}

export const isProfilePage = (pathname: string): boolean => {
  return pathname.includes(authorizedRoutes.profilePage)
}

export const isAllAccessRoute = (pathname: string): boolean => {
  return Object.values(allAccessRoutes).includes(pathname)
}

export const ejentaRoutes = {
  ...allAccessRoutes,
  ...authorizedRoutes
}
